export let PublicationsKey = {
    username : "Authors",
    title : "Title of the Publication",
    branch : "Branch",
    cjb : "C/J/B/BC",
    name_cjb : "Name of C/J/B/BC",
    vol : "Volume",
    issue : "Issue",
    year : "Year",
    month : "Month",
    author_no : "Author Order",
    doi :  "ISSN/ISBN/DOI",
    organised_by : "Organizer",
    is_proceeding : "Is it in Proceedings?(Yes/No)",
    is_published : "Abstartct Published (Yes/No)",
    scl : "SCI/Scopus/WoS/UGC/Others",
    citation_scopus :"No. of Citation(WoS/Scopus)",
    citation_google :"No. of Citation(Google Scholar)",
    is_affilated : "Affiliated?(Yes/No)",
    nationality :  "International/National",
    cite : "Cite Article",
    link : "Publication Link",
    proofingfile : "File ",
    starting_page : "Page Number",
}

export let UsersKey = {
    Name : "Username",
    Email : "Email",
    branch : "Branch",
    admin : "Admin",
    delete : "Delete"
}

export let PatentsKey = {
    title : "Title of the Patent",
    authors : "Applicants of BVRITH",
    pat_no  : "Patent No",
    dept : "Department",
    design_utility : "Design/Utility",
    filed : "Filed Date",
    year : "Year Of Grant",
    published: "Published Date",
    abstract : "Abstract",
    country: "Country",
}

export let ResearchKey = {
    title : "Title of the Project",
    pi : "PI",
    co_pi  : "Co-PI",
    dept : "Department",
    amount : "Amount",
    scheme : "Scheme",
    year : "Start year",
    duration: "Duration in Years"
}

export let ConsultancyKey = {
    title : "Title of the Project",
    industry: "Name of the Industry",
    ngo : "Public/Private/NGO",
    pi : "PI",
    co_pi  : "Co-PI",
    dept : "Department",
    amount : "Amount",

}
export let Departments = ["IT","CSE","ECE","EEE","AI/ML","BS&H"]